import request from "@/utils/request"

export function login(username, password) {
  return request.post('/login', {
    username: username,
    password: password,
  })
}

export function getUser() {
  return request.post('/user')
}

export function resetPwd(old_password, password) {
  return request.post('/resetPassword', {
    old_password: old_password,
    password: password
  })
}

// 用户管理
export function adminPage(params) {
  return request.get('/admins', {params: params})
}

export function adminStore(data) {
  return request.post('/admins', data)
}

export function adminInfo(id) {
  return request.get(`/admins/${id}`)
}

export function adminDelete(id) {
  return request.delete(`/admins/${id}`)
}

export function adminImport(file) {
  let formData = new FormData()
  formData.append('file', file)
  return request.post('/admins/import', formData)
}
